
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaginationControls',

  props: {
    itemsPerPage: { type: [String, Number], default: 5 },
    itemsCount: { type: Number, required: true },
    value: { type: Number, required: true } // current page number
  },

  methods: {
    setPage(pageNumber: number) {
      this.$emit('input', pageNumber);
    }
  },

  computed: {
    currentlyDisplayed(): string {
      const from = Math.max((this.value - 1) * Number(this.itemsPerPage), 1);
      const to = Math.min(this.value * Number(this.itemsPerPage), this.itemsCount);

      return `${from} - ${to}`;
    },

    isPaginationNeeded(): boolean {
      return this.itemsCount > Number(this.itemsPerPage);
    },

    canGoNext(): boolean {
      return this.value * Number(this.itemsPerPage) < this.itemsCount;
    },

    canGoPrevious(): boolean {
      return this.value * Number(this.itemsPerPage) > Number(this.itemsPerPage);
    },
  },
});
